import {useAppSelector} from '@/hooks';
import {DownloadStateTypes} from '@Components/download-panel/download-panel.reducer';

export const useGetIfHeavyOrderIsInProcess = (): boolean => {
  return useAppSelector((state) => {
    const {currentlyProcessingOrderIdKeys, orderStateHashmapNew} = state.downloadDialog;
    return currentlyProcessingOrderIdKeys.some((key) => {
      const orderState = orderStateHashmapNew[key];
      return orderState?.state === DownloadStateTypes.DOWNLOADING && orderState.isHeavyOrder === true;
    });
  });
};
